import { Log } from "@/utils";
import getSessionId from "@/model/session.js";
import SlsTracker from "@aliyun-sls/web-track-browser";
import { useMidStore } from "@/store/midStore";
import { useUserStore } from "@/store/userStore";
import { useIpStore } from "@/store/ipStore";

const VERSION = "v6.4.0";

const opts = {
  host: "ap-southeast-1.log.aliyuncs.com", // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: "easylink", // Project名称。
  logstore: "easylink_tracking_log", // Logstore名称。
  time: 3, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
};

const tracker = new SlsTracker(opts);

const send = async (jsonData) => {
  try {
    jsonData.url = url();
    jsonData.referrer = referrer();
    jsonData.platform = platform();
    jsonData.userAgent = userAgent();
    jsonData.version = VERSION;
    const midStore = useMidStore();
    const userStore = useUserStore();
    const ipStore = useIpStore();
    const mid = await midStore.useMid();
    jsonData.mid = mid;
    if (userStore.unionid) {
      jsonData.unionid = userStore.unionid;
    }
    // 获取并添加 IP 地址
    try {
      const ip = await ipStore.useIp();
      if (ip) {
        jsonData.ip = ip;
      }
    } catch (error) {
      Log.failure("获取 IP 地址失败", error);
    }
    jsonData.logtimestamp = timestamp();
    jsonData.session_id = session();

    tracker.sendImmediate(jsonData);
  } catch (error) {
    Log.failure("tracking data", error);
  }
};

const session = () => getSessionId();

const timestamp = () => Date.now();

const url = () => window.location.href;

const referrer = () => document.referrer;

const platform = () => {
  const userAgent = window.navigator.userAgent;
  const isMobileUA = /Mobile|Android|iPhone|iPad|iPod|Windows Phone/i.test(
    userAgent
  );

  // 检查屏幕尺寸，通常手机屏幕宽度较小
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  // 一般认为宽度小于768px为手机设备，可以根据实际情况调整
  const isSmallScreen = screenWidth < 768 || screenHeight < 768;

  // 检查是否支持触摸事件
  const hasTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);

  // 如果 User Agent 表明是移动设备，或者屏幕尺寸较小且支持触摸，则判断为 mobile-web
  if (isMobileUA || (isSmallScreen && hasTouch)) {
    return "mobile-web";
  } else {
    return "pc-web";
  }
};

const userAgent = () => window.navigator.userAgent;

export default { send, platform };
